import React from "react";
import { Row, Col, Tooltip, Typography } from "antd";

import DhlLogo from "../dhlLogo";

const { Text } = Typography;

const OperationText = ({
  intl,
  cancel,
  intlIdFreApi,
  cancelledUser,
  defaultMessageFreApi,
}) => (
  <Tooltip
    overlayStyle={{
      whiteSpace: "pre-line",
      minWidth: cancelledUser ? 260 : 285,
    }}
    title={
      intl.formatMessage({
        id: intlIdFreApi,
        defaultMessage: defaultMessageFreApi,
      }) +
      (cancelledUser
        ? "\n" +
          intl.formatMessage(
            {
              id: "consignment.state.cancelled.user",
              defaultMessage: "Stornoval uživatel {first} {last}.",
            },
            { first: cancelledUser.firstname, last: cancelledUser.lastname }
          )
        : "")
    }
  >
    <Text code>
      {cancel
        ? intl.formatMessage({
            id: "consignment.cancelled",
            defaultMessage: "Storno",
          })
        : "FREAPI"}
    </Text>
  </Tooltip>
);

const ConsignmentDateTime = ({
  intl,
  intlId,
  freApi,
  dateTime,
  hideText,
  cancelled,
  operation,
  intlIdCancel,
  intlIdFreApi,
  cancelledUser,
  defaultMessage,
  defaultMessageFreApi,
  defaultMessageCancel,
}) => (
  <>
    {!hideText && dateTime}
    {operation ? (
      <DhlLogo
        intl={intl}
        intlId={intlId}
        hideText={hideText}
        defaultMessage={defaultMessage}
      />
    ) : (
      <></>
    )}
    <Row type="flex">
      {freApi && (
        <Col>
          <OperationText
            intl={intl}
            intlIdFreApi={intlIdFreApi}
            defaultMessageFreApi={defaultMessageFreApi}
          />
        </Col>
      )}
      {cancelled && (
        <Col>
          <OperationText
            cancel
            intl={intl}
            intlIdFreApi={intlIdCancel}
            cancelledUser={cancelledUser}
            defaultMessageFreApi={defaultMessageCancel}
          />
        </Col>
      )}
    </Row>
  </>
);

export default ConsignmentDateTime;
